export const ZENDESK_API_REQUESTS_URL =
    "https://cbchelp.zendesk.com/api/v2/requests.json";
